import { shape, string, bool } from "prop-types";

import StyledLink from "../StyledLink/StyledLink.jsx";

const imageShape = shape({
  mobile1X: string.isRequired,
  desktop1X: string.isRequired,
  mobile2X: string.isRequired,
  desktop2X: string.isRequired,
  tablet1X: string.isRequired,
  alt: string,
  text: string,
  icon: bool,
}).isRequired;

const propTypes = {
  image: imageShape,
  name: string,
  title: string,
  interests: string,
  email: string,
  phoneNumber: string,
  profileLink: string,
  linkedInLink: string,
  linkedInLinkText: string,
};

const FeaturedPerson = (props) => {
  const {
    image,
    name,
    title,
    interests,
    email,
    phoneNumber,
    profileLink,
    linkedInLink,
    linkedInLinkText,
  } = props;

  return (
    <div className="featured-person">
      {image && (
        <div className="featured-person__image-wrapper">
          {image.icon && <div className="featured-person__camera-icon"></div>}

          <img
            srcSet={`
            ${image.mobile1X} 250w,
            ${image.desktop1X} 338w,
            ${image.mobile2X} 500w,
            ${image.desktop2X} 676w,
            ${image.tablet1X} 914w,
           `}
            sizes="
            (min-width: 1160px) 338px, 
            (min-width: 680px) calc((100vw - 70px - 70px ) / 3), 
            calc(100vw - 70px)
            "
            src={image.mobile1X}
            alt={image.alt ? image.alt : ""}
            loading="lazy"
          />
          {image.text && image.text !== "" && (
            <div className="featured-person__image-text">
              <div dangerouslySetInnerHTML={{ __html: image.text }}></div>
            </div>
          )}
        </div>
      )}
      <div className="featured-person__content">
        {name && (
          <div className="featured-person__name">
            {profileLink ? (
              <StyledLink href={profileLink}>{name}</StyledLink>
            ) : (
              <span>{name}</span>
            )}
          </div>
        )}
        {title && <div className="featured-person__title">{title}</div>}
        {interests && (
          <div className="featured-person__interests">
            <span>
              <strong>Interests: </strong>
            </span>
            {interests}
          </div>
        )}
        {(email || phoneNumber) && (
          <address className="featured-person__contact">
            {email && (
              <div>
                <a href={`mailto:${email}`}>{email}</a>
              </div>
            )}
            {phoneNumber && (
              <div>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
              </div>
            )}
          </address>
        )}
        {linkedInLink && (
          <div className="featured-person__linkedin">
            <a href={linkedInLink}>
              {linkedInLinkText ? linkedInLinkText : "LinkedIn"}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

FeaturedPerson.propTypes = propTypes;
export default FeaturedPerson;
